/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brave_Swift_Otter_ChangeInputs */

const en_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change email address`)
};

const id_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubah alamat email`)
};

const ms_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tukar alamat e-mel`)
};

const ca_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canviar l'adreça de correu electrònic`)
};

const cs_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změnit e-mailovou adresu`)
};

const da_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skift e-mailadresse`)
};

const de_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse ändern`)
};

const et_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muutke oma e-posti aadress`)
};

const es_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar correo electrónico`)
};

const fr_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier l’adresse e-mail`)
};

const hr_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promijenite e-mail adresu`)
};

const it_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia indirizzo email`)
};

const lv_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mainīt e-pasta adresi`)
};

const lt_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keisti el. pašto adresą`)
};

const hu_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail cím módosítása`)
};

const nl_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mailadres wijzigen`)
};

const nb_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endre e-postadresse`)
};

const pl_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmień adres e-mail`)
};

const pt_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mudar endereço de e-mail`)
};

const ro_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifică adresa de email`)
};

const sk_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmeniť emailovú adresu`)
};

const sl_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spremenite e-naslov`)
};

const fi_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaihda sähköpostiosoite`)
};

const sv_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändra e-postadress`)
};

const vi_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đổi địa chỉ email`)
};

const tr_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta adresini değiştir`)
};

const el_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αλλαγή διεύθυνσης email`)
};

const bg_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смяна на имейл адреса`)
};

const ru_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменить адрес электронной почты`)
};

const sr_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Промена имејл адресе`)
};

const uk_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Змінити адресу електронної пошти`)
};

const ka_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ელფოსტის მისამართის შეცვლა`)
};

const hi_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ईमेल एड्रेस बदलें`)
};

const th_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปลี่ยนที่อยู่อีเมล`)
};

const ko_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일 주소 변경`)
};

const zh_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更改电子邮件地址`)
};

const zh_tw_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`變更電子郵件地址`)
};

const ja_brave_swift_otter_change = /** @type {(inputs: Brave_Swift_Otter_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレスを変更`)
};

/**
* | output |
* | --- |
* | "Change email address" |
*
* @param {Brave_Swift_Otter_ChangeInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const brave_swift_otter_change = /** @type {((inputs?: Brave_Swift_Otter_ChangeInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brave_Swift_Otter_ChangeInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_brave_swift_otter_change(inputs)
	if (locale === "ms") return ms_brave_swift_otter_change(inputs)
	if (locale === "ca") return ca_brave_swift_otter_change(inputs)
	if (locale === "cs") return cs_brave_swift_otter_change(inputs)
	if (locale === "da") return da_brave_swift_otter_change(inputs)
	if (locale === "de") return de_brave_swift_otter_change(inputs)
	if (locale === "et") return et_brave_swift_otter_change(inputs)
	if (locale === "es") return es_brave_swift_otter_change(inputs)
	if (locale === "fr") return fr_brave_swift_otter_change(inputs)
	if (locale === "hr") return hr_brave_swift_otter_change(inputs)
	if (locale === "it") return it_brave_swift_otter_change(inputs)
	if (locale === "lv") return lv_brave_swift_otter_change(inputs)
	if (locale === "lt") return lt_brave_swift_otter_change(inputs)
	if (locale === "hu") return hu_brave_swift_otter_change(inputs)
	if (locale === "nl") return nl_brave_swift_otter_change(inputs)
	if (locale === "nb") return nb_brave_swift_otter_change(inputs)
	if (locale === "pl") return pl_brave_swift_otter_change(inputs)
	if (locale === "pt") return pt_brave_swift_otter_change(inputs)
	if (locale === "ro") return ro_brave_swift_otter_change(inputs)
	if (locale === "sk") return sk_brave_swift_otter_change(inputs)
	if (locale === "sl") return sl_brave_swift_otter_change(inputs)
	if (locale === "fi") return fi_brave_swift_otter_change(inputs)
	if (locale === "sv") return sv_brave_swift_otter_change(inputs)
	if (locale === "vi") return vi_brave_swift_otter_change(inputs)
	if (locale === "tr") return tr_brave_swift_otter_change(inputs)
	if (locale === "el") return el_brave_swift_otter_change(inputs)
	if (locale === "bg") return bg_brave_swift_otter_change(inputs)
	if (locale === "ru") return ru_brave_swift_otter_change(inputs)
	if (locale === "sr") return sr_brave_swift_otter_change(inputs)
	if (locale === "uk") return uk_brave_swift_otter_change(inputs)
	if (locale === "ka") return ka_brave_swift_otter_change(inputs)
	if (locale === "hi") return hi_brave_swift_otter_change(inputs)
	if (locale === "th") return th_brave_swift_otter_change(inputs)
	if (locale === "ko") return ko_brave_swift_otter_change(inputs)
	if (locale === "zh") return zh_brave_swift_otter_change(inputs)
	if (locale === "zh-tw") return zh_tw_brave_swift_otter_change(inputs)
	if (locale === "ja") return ja_brave_swift_otter_change(inputs)
	return en_brave_swift_otter_change(inputs)
});